var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BrandClientService } from "../../../../services/modules/brand-client.service";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { BindingEngine } from "aurelia-binding";
import { autoinject } from "aurelia-framework";
import { Guid } from "../../../../utilities/guid";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { BindingSignaler } from "aurelia-templating-resources";
var ManageLotteryWidgets = /** @class */ (function () {
    function ManageLotteryWidgets(brandClientService, bindingEngine, notificationService, tokenClient, lookupClientService, bindingSignaler) {
        this.brandClientService = brandClientService;
        this.bindingEngine = bindingEngine;
        this.notificationService = notificationService;
        this.tokenClient = tokenClient;
        this.lookupClientService = lookupClientService;
        this.bindingSignaler = bindingSignaler;
        this.widgets = [];
        this.files = {};
        this.cdnImages = __CDN_IMAGES__;
    }
    ManageLotteryWidgets.prototype.activate = function () {
        var _this = this;
        this.brandClientService.getLotteryWidgets().then(function (widgets) {
            _this.widgets = widgets;
            _this._uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.widgets, []);
        });
    };
    ManageLotteryWidgets.prototype.addLotteryWidget = function () {
        this.widgets.push({
            imagePath: null,
            internalName: null,
            name: null,
            lotteryWidgetId: 0,
            isActive: true,
            isDefault: true,
            guid: Guid.generateGuid()
        });
    };
    ManageLotteryWidgets.prototype.getImagePath = function (widgetPath) {
        if (!widgetPath) {
            return "".concat(this.cdnImages, "/others/image-placeholder.svg");
        }
        var storageUri = this.tokenClient.storageUri;
        if (this.tokenClient.storageUri.endsWith('/')) {
            var substringed = this.tokenClient.storageUri.substr(0, this.tokenClient.storageUri.length - 1);
            storageUri = substringed;
        }
        var url = storageUri + widgetPath;
        return url;
    };
    ManageLotteryWidgets.prototype.onNewFile = function (widget, files) {
        if (files)
            this.files[widget.guid] = files.item(0);
        else {
            delete this.files[widget.guid];
            widget.imagePath = "";
        }
        this.bindingSignaler.signal("image-updated");
    };
    ManageLotteryWidgets.prototype.save = function () {
        var _this = this;
        var images = [];
        if (this.files && Object.keys(this.files).length > 0) {
            var keys = Object.keys(this.files);
            images = keys.map(function (x) { return ({ file: _this.files[x], guid: x }); });
        }
        return new Promise(function (resolve, reject) {
            _this.brandClientService.saveLotteryWidgets({ id: 0, changes: _this._uow.getChanges(), images: images }).then(function (response) {
                if (_this._uow) {
                    _this._uow.clearChanges();
                    _this._uow.dispose();
                    _this._uow = null;
                }
                _this.widgets = response.lotteryWidgets;
                _this._uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.widgets, []);
                _this.lookupClientService.clearLookupCache(LookupValueQuery.lotteryWidgets);
                _this.notificationService.show("Save", "Changes saved successfully", NotificationType.Success);
                resolve();
            }).catch(function (ex) {
                _this.notificationService.show("Save", "Error during save of Changes", NotificationType.Error);
                reject();
            });
        });
    };
    ManageLotteryWidgets = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [BrandClientService, BindingEngine, NotificationClientService,
            TokenClient, LookupClientService, BindingSignaler])
    ], ManageLotteryWidgets);
    return ManageLotteryWidgets;
}());
export { ManageLotteryWidgets };
